<div class="container">
  <div class="row default-supplier-allocations justify-content-center">
    <h6 class="text-uppercase text-center fw-bold mb-5">
      Default Supplier Allocation Settings
    </h6>
    <div class="col-sm-12 col-md-3 form-group">
      <div class="row">
        <!-- Country -->
        <div class="col-12 rate-card-dropdown-margin">
          <label for="country-select">Country</label>
          <ps-ui-select-dropdown
            id="country-select"
            [dropdownItems]="countries"
            [field]="'name'"
            [enableSearch]="true"
            labelNone="Select Country"
            [(ngModel)]="selectedCountry"
            [label]="selectedCountry?.name"
            (selectedItem)="selectCountry($event)"
          >
          </ps-ui-select-dropdown>
        </div>
        <!-- Language -->
        <div class="col-12 rate-card-dropdown-margin">
          <label for="language-select">Language</label>
          <ps-ui-select-dropdown
            id="language-select"
            [dropdownItems]="languages"
            [field]="'name'"
            [enableSearch]="true"
            [(ngModel)]="selectedLanguage"
            labelNone="Select Language"
            [label]="selectedLanguage?.name"
            [loading]="isLoading"
            (selectedItem)="selectLanguage($event)"
          >
          </ps-ui-select-dropdown>
        </div>
        <!-- Supplier Allocations -->
        <div class="col-12 rate-card-dropdown-margin">
          <label for="supplier-allocations-input">Supplier Allocations</label>
          <input
            id="supplier-allocations-input"
            class="form-control"
            type="number"
            [(ngModel)]="supplierAllocations"
            psInputRestriction="[0-9.]"
            placeholder="Enter Supplier Allocations"
            psInputDecimalRestriction
            [disabled]="isLoading"
          />
        </div>
        <!-- Supplier Flexibility -->
        <div class="col-12 rate-card-dropdown-margin">
          <label for="supplier-flexibility-input">Supplier Flexibility</label>
          <input
            id="supplier-flexibility-input"
            class="form-control"
            type="number"
            [(ngModel)]="supplierFlexibility"
            (input)="onFlexibilityInput($event)"
            (blur)="onFlexibilityChange()"
            psInputRestriction="[0-9.]"
            placeholder="Enter Supplier Flexibility"
            psInputDecimalRestriction
            [disabled]="isLoading"
          />
        </div>
        <!-- Save Button -->
        <div class="col-12 rate-card-dropdown-margin text-center">
          <button
            type="button"
            psUiButton
            color="primary"
            (click)="saveAllocation()"
            [disabled]="
              !selectedCountry ||
              !selectedLanguage ||
              supplierAllocations === null ||
              supplierFlexibility === null ||
              isLoading
            "
          >
            {{ currentAllocationId ? 'Update' : 'Save' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
